import { Injectable } from '@angular/core';
import { Settings, SettingsResponse } from '../models/settings';
import { ApiService } from './api.service';
import { Platform } from '@ionic/angular';
import { jhcassoAPIUri } from 'src/environments/apiUri';
import { Storage } from '@ionic/storage-angular';
import { TokenResponse } from '../models/Response/TokenResponse';
import OneSignal from 'onesignal-cordova-plugin';

@Injectable({
  providedIn: 'root'
})
export class ApplocalstorageService {

  settingsInfo: Settings = {};
  tokenInfo: TokenResponse;

  constructor(
    private storage: Storage,
    private api: ApiService,
    private platform: Platform
  ) {
    this.initStorage();
  }

  private async initStorage() {
    await this.storage.create();
  }

  async callAppSettingInfo(): Promise<Settings> {

    const result = await this.getAppSettingInfo();

    if (result?.appName) {
      return result;
    }    

    this.api.get(jhcassoAPIUri.settings).subscribe((response: SettingsResponse) => {
        if (response.status) {
          this.settingsInfo = response.data;
          localStorage.setItem('lat', this.settingsInfo.lat);
          localStorage.setItem('lang', this.settingsInfo.lang);
          localStorage.setItem('mapkey', this.settingsInfo.mapkey);
          localStorage.setItem('currency', this.settingsInfo.currencySymbol);
          localStorage.setItem('imagePath', this.settingsInfo.imagePath);
          localStorage.setItem('whitelogo', this.settingsInfo.whiteLogo);
          localStorage.setItem('blacklogo', this.settingsInfo.blackLogo);
          //localStorage.setItem('keyStri', data.stripe_public_key);

          // ✅ OneSignal Initialization (Cordova plugin via Capacitor)
          // if ((window as any).cordova && typeof OneSignal !== 'undefined') {

          //   OneSignal.setAppId("705e5658-4d4c-4d2b-b062-e50e9cece8ee");

          //   OneSignal.getDeviceState((state: any) => {

          //     if (state && state.userId) {
          //       this.api.deviceToken = state.userId;
          //       localStorage.setItem('pushToken', state.userId);
          //       console.log("OneSignal Player ID:", state.userId);
          //     } else {
          //       this.api.deviceToken = null;
          //     }

          //   });

          // } else {
          //   this.api.deviceToken = null;
          // }

          this.setAppSettingInfo(this.settingsInfo);
        }

      },
      (err) => {
        console.error('Error fetching settings', err);
      }
    );

    return this.settingsInfo || null;
  }

  async setAppSettingInfo(settings: Settings) {
    this.settingsInfo = settings;
    await this.storage.set('appSettingInfo', settings);
  }

  async getAppSettingInfo(): Promise<Settings> {
    if (!this.settingsInfo) {
      this.settingsInfo = await this.storage.get('appSettingInfo');
    }
    return this.settingsInfo || null;
  }

  async setTokenInfo(appToken: TokenResponse) {
    this.tokenInfo = appToken;
    await this.storage.set('tokenInfo', appToken);
  }

  async getTokenInfo(): Promise<TokenResponse> {
    if (!this.tokenInfo) {
      this.tokenInfo = await this.storage.get('tokenInfo');
    }
    return this.tokenInfo || null;
  }

  async clearTokenInfo() {
    await this.storage.set('tokenInfo', '');
  }
}
